import { API_CONFIG_URLS } from "../constants/config";
import ApiService from "../services/ApiService";


async function getProfileDetails() {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.AUTH.ME}`
  );
  return response;
}

async function getUsersList(queryParams?: any) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.GET_USERS_LIST}`,
    queryParams
  );
  return response;
}

async function deleteUser(id: any) {
  const response = await ApiService.remove(
    `${API_CONFIG_URLS.USERS.DELETE_USER}/${id}`
  );
  return response;
}

async function getUserDetails({ userId }: { userId: string,  }) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.GET_USER_DETAILS}/${userId}`
  );
  return response;
}

async function updateUserStatus(payload: {
  userId: string;
  activateUser: boolean;
}) {
  const response = await ApiService.put(
    `${API_CONFIG_URLS.USERS.UPDATE_USER_STATUS}`,
    payload
  );
  return response;
}

async function getUsersStats(queryParams?: any) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.GET_USERS_STATS}`,
    queryParams
  );
  return response;
}

async function getUsersRevenue(queryParams?: any) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.GET_USERS_REVENUE}`,
    queryParams
  );
  return response;
}


export const UsersApiService = {
  getProfileDetails,
  getUsersStats,
  getUsersRevenue,
  deleteUser,
  getUserDetails,
  getUsersList,
  updateUserStatus,
};
